import { BeekSessionStatus } from 'src/utils/user';
import { NextArticlePath } from 'src/api/article/dataArticle';
import Alert from 'beek-design-system/Elements/Alert';
import ArticleSection from 'src/components/LandingPage/ArticleSection';
import BenefitsSection from 'src/components/LandingPage/BenefitSection';
import CatologueSection from 'src/components/LandingPage/CatalogueSection';
import DeviceSection from 'src/components/LandingPage/DeviceSection';
import Footer from 'src/components/Common/Footer';
import Helpers from 'src/components/LandingPage/Layout/LandingPageHelpers';
import HomeSection from 'src/components/LandingPage/HomeSection';
import NavBar from 'src/components/LandingPage/NavBar';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
import { Offer } from 'src/api/landing/landing.graphql';

type SubscriptionPlanProps = {
  id: number;
  title: string;
  trial_interval: number;
  trial_interval_unit: string;
  created_at: string;
  updated_at: string;
  deleted_at: null;
  is_enabled: boolean;
  subscription_settings_provider_id: null;
  description: string;
  interval: number;
  interval_unit: string;
  amount: number;
  territories: string;
  priority: number;
  plan_type: string;
};

type ErrorResponse = {
  description: string;
};

type LandingPageLayoutProps = {
  articles: NextArticlePath[];
  discountData?: Offer | null;
  discountError?: ErrorResponse | null;
  plansData?: {
    subscriptionPlansData: SubscriptionPlanProps[];
  };
  sessionStatus: BeekSessionStatus;
};

type PageContainerProps = {
  error: boolean;
};

const defaultProps = {
  discountData: null,
  discountError: null,
  plansData: null,
};

const PageContainer = styled.article<PageContainerProps>`
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  @media ${({ theme }): string => theme.devices.laptop} {
    margin-top: ${(props): string => (props.error ? '4rem' : '2rem')};
  }
`;

const AlertContainer = styled.article`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5.188rem;
  @media ${({ theme }): string => theme.devices.laptop} {
    margin-top: 5rem;
  }
`;

const BenefitsSectionContainer = styled.div`
  width: 100%;
`;

const LandingPageLayout = (props: LandingPageLayoutProps): JSX.Element => {
  const { articles, discountData, plansData, discountError, sessionStatus } =
    props;
  const dataArticleSection = Helpers.getDataArticleSection(articles);
  const dataBenefitSection = Helpers.getDataBenefitSection();
  const dataDiscount = Helpers.getDataDiscount(discountData || null);
  const dataPlans = Helpers.getDataPlans(plansData || null);

  return (
    <>
      <NavBar sessionStatus={sessionStatus} />
      {discountError && (
        <AlertContainer>
          <Alert
            text="El descuento que buscas no existe."
            colorVariant="redAlert"
          />
        </AlertContainer>
      )}
      <PageContainer error={!!discountError}>
        <HomeSection
          {...dataDiscount}
          offer={dataDiscount?.offer || null}
          affiliate={discountData?.affiliate || null}
          dataPlans={dataPlans || []}
        />
        {dataArticleSection.length !== 0 && (
          <ArticleSection type="landing" data={dataArticleSection} />
        )}
        <BenefitsSectionContainer>
          <BenefitsSection data={dataBenefitSection} {...dataDiscount} />
        </BenefitsSectionContainer>
        <CatologueSection />
        <DeviceSection
          {...dataDiscount}
          offer={dataDiscount?.offer || null}
          affiliate={discountData?.affiliate || null}
          dataPlans={dataPlans || []}
        />
      </PageContainer>
      <Footer />
    </>
  );
};

LandingPageLayout.defaultProps = defaultProps;

export default LandingPageLayout;
